import _ from "lodash";

const fetchJson = (url, options = {}) => {
  return fetch(url, options)
    .then((response) => response.json())
    .catch((error) => console.log("fetchJson error", error));
};

const sendEmail = ({ data, formId }) => {
  const url = `${process.env.REACT_APP_FORVIZ_FORM_HOST}/forms/${formId}`;
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };
  return fetchJson(url, options).then((res) => {
    console.log("sendEmail", res);
    if (_.get(res, "data") === "success") {
      return true;
    }
    return false;
  });
};

const fetchApi = (
  url,
  method = "GET",
  data = JSON.stringify({}),
  headers = {}
) => {
  const options = {
    method,
    headers: {
      ...headers,
    },
  };
  if (method === "POST" || method === "PUT") {
    if (headers !== false) {
      options.headers = {
        "Content-Type": "application/json",
        ...options.headers,
      };
    }
    options.body = data;
  }
  return fetchJson(
    `${process.env.REACT_APP_SERVICE}/${process.env.REACT_APP_API}/${url}`,
    options
  );
};

const toObject = (items) => {
  return _.keyBy(items, "id");
};

const stripHtml = (html) => {
  const temporalDivElement = document.createElement("div");
  temporalDivElement.innerHTML = html;
  return temporalDivElement.textContent || temporalDivElement.innerText || "";
};

const splitStringNum = (item) => {
  const str = _.get(item.match(/[a-zA-Z]+/), "0");
  const num = _.padStart(_.get(item.match(/\d+/), "0"), 2, "0");
  return [str, num];
};

export { fetchJson, sendEmail, fetchApi, toObject, stripHtml, splitStringNum };



// WEBPACK FOOTER //
// ./src/utils/index.js